module.exports = __webpack_public_path__ + "img/Frame-left.79a17833.svg";